import { type AggRequest, type AggResponse, fetchAgg } from '../../../common/utils/fetch-agg';

type LoomTagNode = {
	tag: string;
	url: string;
	videoCount: number;
};

const LOOM_TAGS_SEARCH_OPERATION_NAME = 'LoomRovoTagsSearchQuery';
const loomTagsSearchGraphQuery = `
	query ${LOOM_TAGS_SEARCH_OPERATION_NAME}($siteId: ID!, $query: String!, $limit: Int) {
		loom_tagsSearch(siteId: $siteId, query: $query, limit: $limit) {
			tag
			url
			videoCount
		}
	}
`;

export type LoomTagsSearchQueryVariables = {
	siteId: string;
	query: string;
	limit?: number;
};

export type LoomTagsSearchQueryData = {
	loom_tagsSearch: LoomTagNode[] | null;
};

export type LoomTagsSearchQueryProps = Pick<
	AggRequest<LoomTagsSearchQueryVariables>,
	'aggAbsoluteUrl' | 'variables' | 'headers'
>;

export const loomTagsSearchQuery = ({
	variables,
	aggAbsoluteUrl,
	headers,
}: LoomTagsSearchQueryProps): Promise<AggResponse<LoomTagsSearchQueryData>> =>
	fetchAgg<LoomTagsSearchQueryVariables, LoomTagsSearchQueryData>({
		variables,
		aggAbsoluteUrl,
		graphQuery: loomTagsSearchGraphQuery,
		operationName: LOOM_TAGS_SEARCH_OPERATION_NAME,
		headers,
	});
